import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { SegmentValidationService } from '../../validation/segment-validation/segment-validation.service';
import {takeWhile} from 'rxjs/operators';



@Component({
  moduleId: module.id,
  selector: 'hints-validation',
  templateUrl: 'hints-validation.component.html',
  styleUrls: ['hints-validation.component.scss'],
})
export class HintsValidationComponent implements OnInit, OnDestroy {
  isValidationHidden: boolean = true;
  private isPageActive: boolean = true;

  constructor(
    private validationService: SegmentValidationService,
    private ref: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.validationService.setDataEvent
    .pipe(takeWhile(() => this.isPageActive))
    .subscribe((model: any) => {
      this.isValidationHidden = !model.data.length;
      this.ref.markForCheck();
    });
  }

  ngOnDestroy() {
    this.isPageActive = false;
    this.validationService.resetValidation();
  }
}
